import { Theme, withStyles } from '@material-ui/core';
import { Image } from 'components/Image';
import { OrgLogoSrc } from 'config';
import { getWebAppAssetPath } from 'helpers';
import React from 'react';
import { hot } from 'react-hot-loader/root';
import { BannerRhymeCtrl } from './BannerRhyme';
import { SSDNCtrl } from './SSDNCtrl';

const brandBoxStyles = (theme: Theme) => ({
	brandBox: {
		maxWidth: '60em',
		margin: '0 auto',
		[theme.breakpoints.up('xl')]: {
			marginTop: '-20em',
			marginBottom: '-20em',
		},
		[theme.breakpoints.only('lg')]: {
			marginTop: '-18em',
			marginBottom: '-18em',
		},
		[theme.breakpoints.only('md')]: {
			marginTop: '-15em',
			marginBottom: '-15em',
		},
		[theme.breakpoints.only('sm')]: {
			marginTop: '-15em',
			marginBottom: '-15em',
			width: '90%',
		},
		[theme.breakpoints.down('xs')]: {
			marginTop: '-10em',
			marginBottom: '-10em',
			width: '80%',
		},
	},
	glowImg: {
		display: 'block',
		width: '100%',
		'animation-name': 'sphamadjust-hue',
		'animation-duration': '40000ms',
		'animation-iteration-count': 'infinite',
		'animation-timing-function': 'linear',
	},
	brandImg: {
		display: 'block',
		width: '100%',
		transform: 'rotate(0)',
		marginTop: '-100%',
	},
});

class BrandBoxComponent extends React.Component<{ classes?: any; glowImgSrc: string; brandImgSrc: string }> {
	render() {
		let { classes } = this.props;

		return (
			<div className={classes.brandBox}>
				<Image className={classes.glowImg} src={this.props.glowImgSrc} />
				<Image className={classes.brandImg} src={this.props.brandImgSrc} />
			</div>
		);
	}
}

const BrandBox = withStyles(brandBoxStyles)(BrandBoxComponent);

const bannerStyles = (theme: Theme) => ({
	background: {
		position: 'initial !important' as 'initial',
		backgroundImage: `url(${getWebAppAssetPath('bg/new-banner-double.jpg')})`,
		backgroundSize: '100% 100%',
		overflow: 'hidden',
		marginTop: -2,
		[theme.breakpoints.up('xl')]: {
			fontSize: 17,
		},
		[theme.breakpoints.only('lg')]: {
			fontSize: 15,
		},
		[theme.breakpoints.only('md')]: {
			fontSize: 14,
		},
		[theme.breakpoints.down('sm')]: {
			fontSize: 13,
		},
	},
});

class Component extends React.Component<{ classes?: any }> {
	render() {
		let { classes } = this.props;

		return (
			<React.Fragment>
				{/* <img src='/assets/img/waterfall.gif' style={{ maxWidth: '100%', margin: 'auto', display: 'block' }} /> */}
				<img src='/assets/img/waterfall.gif' style={{ width: '100%', margin: 'auto', display: 'block' }} />
			</React.Fragment>
		);
		return (
			<div className={classes.background}>
				<SSDNCtrl />
				<BrandBox brandImgSrc={getWebAppAssetPath(OrgLogoSrc)} glowImgSrc={getWebAppAssetPath('glow.png')} />
				<BannerRhymeCtrl />
			</div>
		);
	}
}

export const Banner = hot(withStyles(bannerStyles)(Component));
